import React, { FC } from 'react';
import urlJoin from 'url-join';
import styles from './styles.module.css';
import { Switch, RouteComponentProps, Route } from 'react-router';
import {
  PolicyList,
  PolicyDetails,
  PolicySummary,
  PolicyDraft,
  PolicyPayPlanSummary,
} from 'Policies/screens';
import { AnimatePresence } from 'framer-motion';

export const Router: FC<RouteComponentProps> = ({ match }) => {
  return (
    <div className={styles.container}>
      <AnimatePresence mode="wait">
        <Switch>
          <Route
            path={urlJoin(match.url, '/:id/draft/:draftId/summary')}
            component={PolicySummary}
            key="draftSummary"
          />
          <Route
            path={urlJoin(match.url, '/:id/payPlan/summary')}
            component={PolicyPayPlanSummary}
            key="payPlanSummary"
          />
          <Route
            path={urlJoin(match.url, '/:id/draft/:draftId/payPlan/summary')}
            component={PolicyPayPlanSummary}
            key="draftPayPlanSummary"
          />
          <Route
            path={urlJoin(match.url, '/:id/draft/:draftId')}
            component={PolicyDraft}
            key="draft"
          />
          <Route
            path={urlJoin(match.url, '/:id/term/:termNumber')}
            component={PolicyDetails}
            key="policyDetailsTerm"
          />
          <Route
            path={urlJoin(match.url, '/:id')}
            component={PolicyDetails}
            key="policyDetails"
          />
          <Route path={match.url} component={PolicyList} key="policyList" />
        </Switch>
      </AnimatePresence>
    </div>
  );
};
